<template>
  <div class="trasporti-mobile" v-loading="loading">
    <div v-show="showPrincipal">
      <div class="row row-custom trasporti-header">
        <div class="col-14 titolo no-padding">
          <span>{{ $t('trasporti.label.title') }}</span>
        </div>
        <div class="col-10 action no-padding">
          <div class="add" v-if="enableAction('add')" @click="add">
            <icon name="riv-add_2" scale="2" class="pointer"></icon>
          </div>
        </div>
      </div>

      <el-table :data="trasporti" @row-click="open" :empty-text="$t('trasporti.msg.noData')" class="el-table_mobile">

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope" slot="header">
            <div class="icon-title" :key="scope.length">
              <el-popover placement="top" v-model="visibleInfo">
                <div>
                  <div>
                    <icon name="riv-circle" class="status-saved" scale="0.8"></icon>
                    <span>{{ $t('statusDett.0') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-send" scale="0.8"></icon>
                    <span>{{ $t('statusDett.1') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-rejected" scale="0.8"></icon>
                    <span>{{ $t('statusDett.2') }}</span>
                  </div>
                  <div>
                    <icon name="riv-circle" class="status-approved" scale="0.8"></icon>
                    <span>{{ $t('statusDett.3') }}</span>
                  </div>
                </div>

                <span slot="reference">
                  <icon class="pointer" name="riv-help" scale="1"></icon>
                </span>
              </el-popover>

            </div>
          </template>


          <template slot-scope="scope">
            <div class="data-wrapper">
              <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
                placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoAvanz)" :class="getStatoClass_dett(scope.row.statoAvanz)"
                  scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('trasporti.label.giorno')" width="100"
          class-name="sfondino">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <span class="block">{{ scope.row.giorno | formattaData }}</span>
              <span class="block"> {{ scope.row.oraPart | formattaHours }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="$t('trasporti.label.tratta')" class-name="">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <span class="block truncate">{{ scope.row.partenza }}</span>
              <span class="block truncate"> {{ scope.row.destinazione }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope">
            <div class="name-wrapper" :key="scope.length" @click.stop.prevent v-if="enableAction('del')">
              <el-tooltip placement="left" popper-class="popover-mobile" effect="light">
                <template slot="content">
                  <div @click="del(scope.row)" v-if="enableAction('del')">
                    <span>{{ $t('trasporti.label.delete') }}</span>
                  </div>
                </template>

                <icon class="pointer action" name="riv-more" scale="1.5"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" background layout="prev, pager, next"
        :total="nrItems" :page-size="pag_for" @current-change="changePage">
      </el-pagination>
    </div>

    <!-- Dialog di creazione di una nuova richiesta di ferie -->
    <div v-show="showModal" class="el-form_mobile">

      <div class="el-form-header row row-custom">
        <div class="el-form-action col-2 no-padding">
          <icon name="riv-arrow2" scale="1.2" flip="horizontal" @click.native="closeModal('showModal')"></icon>
        </div>
        <div class="el-form-title col-20 no-padding">
          {{ $t('trasporti.label.title').toUpperCase() }}
        </div>
      </div>

      <el-form class="el-form-body" :disabled="formDisabled">
        <div class="elemento row row-custom"
          :class="[!this.validaTrasporto && (this.form.giorno === undefined || this.form.giorno === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('trasporti.label.giorno') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input type="date" v-model="form.giorno" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom"
          :class="[!this.validaTrasporto && (this.form.oraPart === undefined || this.form.oraPart === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('trasporti.label.orarioPart') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input type="time" v-model="form.oraPart" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom"
          :class="[!this.validaTrasporto && (this.form.partenza === undefined || this.form.partenza === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('trasporti.label.partenza') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input v-model="form.partenza" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom"
          :class="[!this.validaTrasporto && (this.form.destinazione === undefined || this.form.destinazione === '') ? 'row-error' : '']">
          <div class="el-form-label col-24 no-padding">{{ $t('trasporti.label.destinazione') + ' (*)' }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input v-model="form.destinazione" class="first" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('trasporti.label.note') }}</div>
          <div class="el-form-input col-24 no-padding" style="height: 100%;">
            <div class="input-wrapper">
              <textarea v-model="form.notaDip" class="first" rows="5" :disabled="formDisabled"
                :class="formDisabled ? 'field-disabled' : ''" />
            </div>
          </div>
        </div>

        <div v-if="form.statoAvanz !== '0'">
          <div class="elemento row row-custom">
            <div class="my-area col-24 no-padding">
              {{ $t('trasporti.label.segreteria') }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.desMezzo !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('trasporti.label.tipoTrasp') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.desMezzo }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.nomeAutista !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('trasporti.label.nominativo') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.nomeAutista }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.oraInizio !== '' && form.oraFine !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('trasporti.label.orario') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.oraInizio }} - {{ form.oraFine }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.notaSeg !== ''">
            <div class="my-label col-8 no-padding">
              {{ $t('trasporti.label.noteSegreteria') }}
            </div>
            <div class="my-value col-16 no-padding">
              {{ form.notaSeg }}
            </div>
          </div>
          <div class="elemento row row-custom" v-if="form.nomeFile !== ''">
            <div @click="getDoc(form.nomeFile)">
              <icon name="riv-download" scale="1.5"></icon>
              <span class="truncate applicazione">{{ form.nomeFile }}</span>
            </div>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="">
        <el-button class="mobile-el-button primary" v-if="!formDisabled" @click="checkSave()">{{ $t('btn.salva')
          }}</el-button>
        <el-button class="mobile-el-button secondary" v-if="formDisabled" @click="closeModal('showModal')">{{
          $t('btn.close') }}</el-button>
        <el-button class="mobile-el-button secondary" v-if="!formDisabled" @click="closeModal('showModal')">{{
          $t('btn.annulla') }}</el-button>
      </span>

    </div>
    <!--</el-dialog>-->

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TrasportiMobile',
  props: ['trasferta'],
  i18n: {
    messages: {
      it_IT: {
        trasporti: {
          label: {
            title: 'Trasporto',
            giorno: 'Giorno',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            tratta: 'Tratta',
            orarioPart: 'Ora di Partenza',
            orarioArrivo: 'Ora di Arrivo',
            orario: 'Orario',
            note: 'Nota',
            segreteria: 'Segreteria',
            tipoTrasp: 'Tipo Trasporto',
            nominativo: 'Nominativo',
            noteSegreteria: 'Note Segreteria',
            delete: 'Elimina'
          },
          msg: {
            noData: 'Nessun Documento trovato',
            datiObbligatoriMancanti: 'Dati obbligatori mancanti'
          }
        }
      },
      fr_FR: {
        trasporti: {
          label: {
            title: 'Réserver Transport',
            giorno: 'Jour',
            partenza: 'Départ',
            destinazione: 'Destination',
            tratta: 'Route',
            orarioPart: 'heure de départ',
            orarioArrivo: 'heure de arrivé',
            orario: 'Horaire',
            note: 'Notes',
            segreteria: 'Secrétaire',
            tipoTrasp: 'Type de transport',
            nominativo: 'Nom',
            noteSegreteria: 'Annotations de la Secrétaire',
            delete: 'Supprimer'
          },
          msg: {
            noData: 'Aucun document trouvé',
            datiObbligatoriMancanti: 'Données obligatoires manquantes'
          }
        }
      },
      es_ES: {
        trasporti: {
          label: {
            title: 'Transporte',
            giorno: 'Día',
            partenza: 'Salida',
            destinazione: 'Destino',
            tratta: 'Ruta',
            orarioPart: 'Hora de salida',
            orarioArrivo: 'Hora de llegada',
            orario: 'Horas',
            note: 'Nota',
            segreteria: 'Secretaria',
            tipoTrasp: 'Tipo de transporte',
            nominativo: 'Nominativo',
            noteSegreteria: 'Nota de la Secretaria',
            delete: 'Borrar',
          },
          msg: {
            noData: 'Sin informacion',
            datiObbligatoriMancanti: 'Faltan datos obligatorios'
          }
        }
      },
      de_DE: {
        trasporti: {
          label: {
            title: 'Transport',
            giorno: 'Tag',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            tratta: 'Route',
            orarioPart: 'Abfahrtszeit',
            orarioArrivo: 'Ankunftszeit',
            orario: 'Zeitraum',
            note: 'Notiz',
            segreteria: 'Sekretariat',
            tipoTrasp: 'Art des Transports',
            nominativo: 'Name',
            noteSegreteria: 'Notiz des Sekretariat',
            delete: 'Löschen'
          },
          msg: {
            noData: 'Keine Tickets gefunden',
            datiObbligatoriMancanti: 'Fehlende Pflichtangaben'
          }
        }
      },
      en_GB: {
        trasporti: {}
      }
    }
  },
  data() {
    return {
      showPrincipal: true,
      visibleInfo: false,
      loading: false,
      trasporti: [],
      currentPage: 1,
      pag_for: 8,
      pag_order: 'DD',
      nrPages: 0,
      nrItems: 0,
      showModal: false,
      form: {},
      tbl_mezzi: [],
      formDisabled: false,
      validaTrasporto: true
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  beforeMount: function () {
    this.formDisabled = this.trasferta.terminata === 'T' ? true : false
    this.loading = true
    this.loadTrasporti()
  },
  mounted: function () {
  },
  methods: {
    loadTrasporti: function () {
      this.loading = true
      this.$set(this, 'trasporti', [])
      this.$http.get('trasferte/' + this.$store.state.country + '/trasporti', {
        params: {
          idTrasferta: this.trasferta.idTrasferta,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.pag_order
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.trasporti = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            if (response.body.msg[0].msgId !== '1218') {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'trasporti', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.loading = false
        })
    },
    add: function () {
      this.validaTrasporto = true
      this.$set(this, 'form', {})
      this.$set(this.form, 'giorno', moment(this.trasferta.dataDal, "YYYYMMDD").format("YYYY-MM-DD"))
      this.form.id = ''
      this.form.idTrasferta = this.trasferta.idTrasferta
      this.form.statoAvanz = '0'
      this.openModal("showModal")
    },
    open: function (row, event, column) {
      this.validaTrasporto = true
      this.$set(this, 'form', {})
      this.form.idTrasferta = row.idTrasferta
      this.form.statoAvanz = row.statoAvanz
      this.form.id = row.id
      this.$set(this.form, 'giorno', moment(row.giorno, "YYYYMMDD").format("YYYY-MM-DD"))
      this.$set(this.form, 'oraPart', moment(row.oraPart, 'HH,mm').format('HH:mm'))
      this.$set(this.form, 'partenza', row.partenza)
      this.$set(this.form, 'destinazione', row.destinazione)
      this.$set(this.form, 'notaDip', row.notaDip.split("\\n").join("\n"))

      // Segretria
      this.form.notaSeg = row.notaSeg
      this.form.desMezzo = row.desMezzo
      this.form.nomeAutista = row.nomeAutista
      this.form.oraInizio = row.oraInizio
      this.form.oraFine = row.oraFine
      this.form.nomeFile = row.nomeFile

      // Show Modal
      this.openModal("showModal")
    },
    checkSave: function () {
      this.validaTrasporto = true
      if (this.form.giorno === '' || this.form.giorno === undefined) {
        this.validaTrasporto = false
      }
      if (this.form.oraPart === '' || this.form.oraPart === undefined) {
        this.validaTrasporto = false
      }
      if (this.form.partenza === '' || this.form.partenza === undefined) {
        this.validaTrasporto = false
      }
      if (this.form.destinazione === '' || this.form.destinazione === undefined) {
        this.validaTrasporto = false
      }

      if (this.validaTrasporto) {
        this.save()
      } else {
        this.$message.error(this.$i18n.t('trasporti.msg.datiObbligatoriMancanti'))
      }
    },
    save: function () {
      let _this = this
      this.loading = true

      let obj = {
        idTrasferta: this.form.idTrasferta,
        id: this.form.id === '' ? '' : this.form.id,
        operazione: this.form.id === '' ? '*ADD' : '*UPD',
        giorno: moment(this.form.giorno, 'YYYY-MM-DD').format('YYYYMMDD'),
        oraPart: moment(this.form.oraPart, 'HH:mm').format('HH.mm.ss'),
        partenza: this.form.partenza,
        destinazione: this.form.destinazione,
        notaDip: this.form.notaDip,
        statoAvanz: this.form.statoAvanz
      }

      this.$http.post('trasferte/' + this.$store.state.country + '/trasporto', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadTrasporti()
            this.closeModal("showModal")
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    del: function (row) {
      this.loading = true
      this.$http.delete('trasferte/' + this.$store.state.country + '/trasporto/' + row.idTrasferta + '/' + row.id)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadTrasporti()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.loadTrasporti()
    },
    getDoc: function (nomeFile) {
      //let url = ('download/trasferta?fileName=' + nomeFile + '&country=' + this.$store.state.country + '&token=' + sessionStorage.getItem('token'))
      let url = ('download/document?codLang=' + sessionStorage.getItem('codLang') + '&delete=NO' +
        '&fileName=' + nomeFile + '&filePath=PaiCEDEXP' + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    isDisabled: function () {
      if (this.trasferta.terminata === 'T' || this.form.id != '') {
        return true
      } else {
        return false
      }
    },
    enableAction: function (action, row) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      switch (action) {
        case 'del':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '5') {
            return true
          } else {
            return false
          }
        case 'add':
          if (statoTrasferta === '0' || statoTrasferta === '1' || statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') {
            return true
          } else {
            return false
          }
      }
      return false
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    openModal: function (field) {
      this.$set(this, field, true)
      this.$set(this, 'showPrincipal', false)
      this.$emit('showModalComponent', false)
    },
    closeModal: function (field) {
      this.$set(this, field, false)
      this.$set(this, 'showPrincipal', true)
      this.$emit('showModalComponent', true)
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-table_mobile.less";
@import "../../assets/less/el-form_mobile.less";

.trasporti-mobile {
  // height: 100%;
  //min-width: 1250px;
  margin-bottom: 70px;
  max-width: 100%;

  .trasporti-header {
    height: 40px;
    margin-top: 10px;
    margin-bottom: 10px;

    .titolo {
      .set-font(@size: 16px, @color: @greenRiva, @family: "os-bold");
      text-align: left;
      line-height: 40px;
    }

    .action {
      text-align: right;
      line-height: 40px;

      .add {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }

      .send {
        // position: fixed;
        // right: 20px;
        // bottom: 20px;
        float: right;
        color: #FF791A;
        margin-right: 10px;
        margin-left: 10px;
      }
    }
  }

  .el-checkbox {
    margin-bottom: 0px;
    margin-top: 10px;

    .el-checkbox__inner {
      border-radius: 0px;
    }

    &.is-checked {
      .el-checkbox__inner {
        background-color: @greenRiva;
        border-color: @greenRiva;
      }
    }
  }

  /*.el-form_mobile {
      margin-bottom: 60px;
    }*/

  .popover-mobile {
    line-height: 50px;
    .set-font(@size: 18px, @color: @grayTesto, @family: "os-semibold")
  }

  .row {
    &.row-error {
      .el-form-label {
        color: red !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/TrasportiMobile.vue